export default {
  //Item photo
  Photo: "Foto",
  ChoosePhoto: "Pilih foto",
  RemovePhoto: "Hapus foto",
  //Order panel
  CurrentOrder: "Pesanan saat ini",
  NoItemsYet: "Belum ada item",
  TapAnItemToAddIt: "Ketuk item untuk menambahkannya ke pesanan",
  //Login
  SetOwnerPin: "Buat PIN Pemilik",
  SetPin: "Buat PIN",
  EnterValidName: "Masukan Nama Asli",
  PinMustBeExactly4Characters: "PIN harus 4 angka",
  PinCodeDoesNotMatch: "Kode PIN tidak cocok",
  //Drawer
  Sales: "Penjualan",
  Receipts: "Tanda Terima",
  Listings: "Daftar",
  Shift: "Absen",
  ShiftReports: "Laporan Absen",
  Settings: "Pengaturan",
  LogoutAttendant: "Keluar Bertugas",

  //Sales
  Subtotal: "Total keseluruhan",
  Tax: "Pajak",
  Discounts: "Diskon",
  TotalPayment: "Total Pembayaran",
  Favorites: "Favorit",
  All: "Semua",
  Payment: "Pembayaran",
  ItemFavorites: "Barang Favorit",
  WouldYouLikeToIncludeTheItemAsFavorites:
    "Apakah anda ingin menambah barang ini kedalam daftar favorit?",
  WouldYouLikeToRemoveTheItemAsFavorites:
    "Apakah anda ingin menghapus barang ini dari daftar favorit?",
  EditPrice: "Rubah Harga",
  SetPrice: "Tetapkan Harga",
  EditTransactionLine: "Rubah jalur transaksi",
  Quantity: "Jumlah",
  SetQuantity: "Set Jumlah",
  Set: "Set",
  SetCommission: "Set Komisi",
  Add: "Tambah",
  ReceiptLineIsDeleted: "Tanda terima dihapus",
  Okay: "Ok",
  ItIsNotYourShift: "Ini bukan absen anda",
  //Sales Delete Icon
  ConfirmDelete: "Konfirmasi hapus",
  AreYouSureToDeleteReceiptLines:
    "Apakah anda yakin mau menghapus tanda terima?",
  No: "Tidak",
  Yes: "Ya",

  //Sales Discount Icon
  Discount: "Diskon",
  PleaseAddAnItem: "Silahkan tambah barang",
  OK: "OK",
  OnTheFlyDiscount: "Diskon Langsung",
  ExistingDiscount: "Diskon yang sudah ada",
  DiscountType: "Tipe diskon",
  Percentage: "Persen",
  SetDiscount: "Set Diskon",
  FixDiscount: "Rubah Diskon",
  CurrentDiscountSelected: "Diskon Saat Ini Dipilih",
  NoSelectedDiscount: "Diskon Saat Ini tidak Dipilih",
  SelectNewDiscount: "Pilih diskon baru",

  //Sales Search
  SearchItems: "Cari Barang",

  //Sales View Orders
  ViewOrders: "Lihat Pesanan",
  NoOrdersYet: "Tidak ada Pesanan",
  ConfirmOrder: "Konfirmasi Pesanan",
  SelectOrderType: "Pilih tipe pesanan",
  Cancel: "Batal",
  Confirm: "Konfirmasi",
  AnyPendingTransactionsWillBeOverridedWouldYouLikeToContinue:
    "Setiap Transaksi Tertunda Akan Digantikan. Apakah Anda ingin melanjutkan?",
  Orders: "Pesanan",
  ORDER: "PESAN",
  CancelOrder: "Batalkan Pesanan",
  TableNo: "No. Meja",
  TableNumber: "Nomer Meja",
  ChangeTable: "Ganti Meja",
  ReprintOrder: "Print Ulang Pesanan",

  //Payment
  Pay: "Bayar",
  AmountDue: "Jumlah yang harus dibayar",
  AmountChange: "Jumlah Kembalian",
  Customer: "Pelanggan",
  PaymentType: "Tipe Pembayaran",
  PrinterStatus: "Status Printer",
  NoDefaultPrinter: "Tidak ada Printer Utama",
  AddCustomer: "Tambah Pelanggan",
  Cash: "Tunai",
  Card: "Karti",
  ConfirmPayment: "Konfirmasi Pembayaran",
  AreYouSure: "Apakah anda yakin?",
  Proceed: "Proses",
  ReceiptInformation: "Informasi Tanda Terima",
  DoYouWantToPrintReceipt: "Apakah anda ingin print tanda terima?",
  Close: "Tutup",
  TransactionSummary: "Ringkasan Transaksi",
  CashPaid: "Pembayaran tunai",
  Commission: "Komisi",
  Alert: "Perhatian",
  AmountPaidMustBeGreaterThanOrEqualToAmuntDue:
    "Jumlah yang Dibayar harus lebih besar dari atau sama dengan Jumlah yang Terutang",
  Email: "Email",
  PhoneNumber: "Nomer HP",
  Note: "Catatan",
  Save: "Simpan",
  NoAddedPrinterDevice: "Tidak ada perangkat printer yang ditambahkan",

  //Receipt
  NoReceiptsAvailable: "Tidak ada tanda terima yang tersedia",
  Receipt: "Tanda terima",
  Completed: "Selesai",
  Attendant: "Pegawai",
  Offline: "Offline",
  Reprint: "Print Ulang",
  CancelReceipt: "Batalkan Tanda Terima",
  SoldTo: "Dijual Ke:",
  Total: "Jumlah",
  NoTax: "tidak ada pajak",
  NoDiscount: "tidak ada diskon",
  AmountPaid: "Jumlah yang dibayar",
  Transaction: "Transaksi",
  VoidReceipt: "Batalkan tanda terima",
  AreYouSureYouWantToVoidReceipt:
    "Apakah Anda yakin ingin membatalkan tanda terima?",
  Reason: "Alasan",
  Cancelled: "Di Batalkan",

  //Listings
  Items: "Barang",
  Item: "Barang",
  Categories: "Kategori",
  WouldYouLikeToCreateNewItem: "Apakah Anda ingin membuat barang baru?",
  WouldYouLikeToCreateNewCategory: "Apakah Anda ingin membuat kategori baru?",
  WouldYouLikeToCreateNewDiscount: "Apakah Anda ingin membuat diskon baru?",
  CreateNewItem: "Buat Barang Baru",
  CreateNewCategory: "Buat Kategori Baru",
  CreateNewDiscount: "Buat Diskon Baru",

  //Listings Items
  Category: "Kategori",
  NoCategory: "No. Kategori",
  Price: "Harga",
  Barcode: "Barcode",
  SoldBy: "Dijual oleh",
  Each: "tiap",
  Weight: "Berat",
  OtherInformation: "Informasi Lain",
  StockKeepingUnit: "Unit Penyimpanan Stok",
  Color: "Warna",
  Shape: "Bentuk",
  ShowOptions: "Tampilkan Opsi",
  PrintBarcode: "Print Barcode",
  HideOptions: "Sembunyikan Opsi",
  SaveNewItem: "Simpan barang baru",
  SuccessfullyAddedNewItem: "Berhasil menambahkan barang baru",

  //Listings categories
  CategoryName: "Nama Kategori",
  ColorWillApplyToAllItemsUnderThisCategoryForWhichColorIsNotSet:
    "Warna akan berlaku untuk semua item di bawah kategori ini yang warnanya tidak ditetapkan",
  SaveNewCategory: "Simpan Kategori Baru",
  EnterValidCategoryName: "Masukkan Nama Kategori yang benar",
  EnterValidDiscountName: "Masukkan Nama Diskon yang benar",
  EnterAValidItemName: "Masukkan Nama Barang yang benar",
  EnterValidDiscountValue: "Masukkan Nilai Diskon yang benar",
  SuccessfullyAddedCategory: "Sukses menambah kategori",
  SuccessfullyAddedDiscount: "sukses menambah diskon",

  //Listings Discounts
  DiscountName: "Nama diskon",
  DiscountValue: "Nilai Diskon",
  Role: "Peran",

  //Shift
  InputValidReason: "Masukan Alasan yang benar",
  AddedCash: "Menambahkan uang tunai",
  CashPayoutIsGreaterThanTheCashAvailable:
    "Pembayaran Tunai lebih besar dari uang tunai yang tersedia",
  RemovedCash: "Uang tunai yang dihapus",
  ShiftDetails: "Rincian Absen",
  Amount: "Jumlah",
  Payin: "Pembayaran Masuk",
  Payout: "Pembayaran Keluar",
  ShiftStarted: "Mulai Absen",
  ShiftStartedOn: "Absen mulai dari",
  BeginningCash: "Uang tunai awal",
  EndingCash: "Uang tunai terakhir",
  ShiftOpenedBy: "Absen dibuka oleh",
  CloseShift: "Tutup absen",
  TheCashYouWantedToPutIntoTheRegisterOrGetOutFromTheRegister:
    "Uang tunai yang ingin Anda masukkan ke kasir atau keluar dari kasir",
  ActualMoney: "Uang Sebenarnya",
  SetActualMoney: "Set Uang Sebenarnya",
  InvalidAmount: "Jumlah tidak benar",
  EndedShift: "Absen Berakhir",
  WorkedFor: "Bekerja pada",
  AndEndedOn: "dan berakhir pada",
  StartAnotherShift: "Mulai absen lain",
  TheCashByTheStartOfTheShift: "Uang tunai pada awal absen",
  EnterABeginningCash: "Masukan uang tunai awal",

  //Shift Reports
  ItemSalesReport: "Laporan barang terjual",
  CommissionReport: "Laporan Komisi",
  GenerateZReading: "Membuat Bacaan Z",
  NoZReadingGenerated: "Tidak ada Z yang di buat",
  ZReadin: "Bacaan Z",
  Opened: "Dibuka",
  by: "oleh",
  TotalNetSales: "Total Penjualan Bersih",
  Transactions: "Transaksi",
  OpeningAmount: "Jumlah Pembukaan",
  ExpectedDrawer: "Laci yang Diharapkan",
  Short: "Rugi",
  CashSales: "Penjualan Tunai",
  Payouts: "Pembayaran",
  Payins: "Biaya masuk",
  Taxes: "Pajak",
  Commissions: "KOmisi",
  PrintXReport: "Print Laporan X",
  ShiftInfo: "Info Absen",
  PrintReport: "Print Laporan",
  PrintCommissions: "Print Komisi",
  Name: "Nama",
  PrintZReport: "Print Lapooran Z",

  //Settings
  //Bluetooth
  Bluetooth: "Bluetooth",
  Company: "Perusahaan",
  Sync: "Sinkronkan",
  Queueing: "Antrian",
  Printer: "Mesin Cetak",
  RegisteredDevices: "Perangkat Terdaftar",
  AvailableDevices: "Perangkat yang tersedia",
  BluetoothScanner: "Bluetooth Scanner",
  Enable: "Diaktifkan",
  Connected: "Tersambung",
  Connecting: "Menyambung...",
  NotConnected: "Tidak Konek",
  AddDevice: "Tambah Perangkat",
  AreYouSureYouWantToAddThisDevice:
    "Apakah anda yakin mau menambah perangkat ini?",
  AreYouSureYouWantToRemoveThisDevice:
    "Apakah anda yakin mau menghapus perangkat ini?",
  SuccessfullyAddedDevice: "Sukses Menambah Perangkat",
  SuccessfullyRemovedDevice: "Sukses Menghapus Perangkat",
  RemoveDevice: "Hapus Perangkat",

  //Company
  CompanySettings: "Pengaturan Perusahaan",
  Currency: "Mata Uang",
  CompanyHeader: "Company Header",
  CompanyFooter: "Company Footer",
  CurrentlyEditingPleaseSaveYourChanges:
    "sedang mengedit. Harap simpan perubahan Anda",

  //Attendant
  AddRole: "Tambah Role",
  AttendantName: "Nama Pegawai",
  CanLogin: "Bisa Masuk",
  SaveAttendant: "Simpan Pegawai",
  Pin: "Pin",
  ConfirmPin: "Konfirmasi PIN",
  SuccessfullyAddedAttendant: "Sukses Menambah Pegawai",
  EnterValidPin: "Masukan PIN yang benar",
  PleaseConfirmPin: "Silahkan Konfirmasi PIN",

  //Sync
  Server: "Server",
  SyncSettings: "Pengaturan Sinkron",
  Username: "Nama Pengguna",
  Password: "Kata Sandi",
  DeviceID: "ID Perangkat",
  PleaseClickTheEditButton: "Silakan klik tombol edit (ikon pensil)",
  EnterValidAttendantName: "Masukkan Nama pegawai yang benar",
  //Queueing
  OtherSettings: "Pengaturan Lain",
  UseDescription: "Gunakan Deskripsi",
  DescriptiveItemNamesInTheListing: "Nama barang deskriptif dalam daftar",
  UseDefaultCustomer: "Gunakan Pelanggan Standar",
  SetItemStacking: "Set Susunan Barang",
  Use: "Gunakan",
  EnableThe: "Aktifkan",
  Feature: "fitur",
  HostAddress: "Alamat Host",

  //Logout
  ConfirmLogout: "Konfirmasi keluar",
  AreYouSureYouWantToLogout: "Apakah anda yakin mau keluar?",

  //Select Attendant
  SelectAttendant: "Pilih Pegawai",
  Next: "Lanjut",
  None: "Tidak Ada",
  EnterPin: "Masukan PIN",
  NoAttendant: "No Pegawai",
  PleaseSelectAnyAttendant: "Silahkan pilih salah satu pegawai",
  PINError: "PIN Salah",
  PleaseEnterTheCorrectPINNumber: "Silahkan masukan nomer PIN yang benar",
  //Late Additionals
  SetTheShift: "Set the shift",
  AttendantAlreadyAdded: "Attendant Already Added",
  NoItemBasedOnTheBarcode: "No item based on the barcode",
  QuantityIsNotAllowed: "Quantity is not allowed",
  ReceiptLineIsModified: "Receipt line is modified",
  UnableToDeleteReceiptLine: "Unable to delete receipt line.",
  ConfirmOrderCancel: "Confirm Order Cancel",
  ConfirmOrderClose: "Confirm Order Close",
  WouldYouLikeToCancelTheOrder: "Would you like to cancel the order?",
  WouldYouLikeToCloseTheOrder: "Would you like to close the order?",
  IsCancelled: "is cancelled",
  Order: "Order",
  ConfirmTableChange: "Confirm Table Change",
  WouldYouLikeToChangeTable: "Would you like to change table?",
  TableNumberChanged: "Table Number Changed",
  UnableToTakeAwayOrder: "Unable to take-away order.",
  SaveNew: "Save new",
  Edit: "Edit",
  VerifyCode: "Verify code",
  Verify: "Verify",
  ResendCode: "Resend Code",
  CashedOut: "Cashed Out",
  TaxPercentage: "Tax Percentage",
  ItemName: "Item Name",
  AddNewItem: "Add new item",
  WouldYouLikeToCreateNew: "Would you like to create new",
  CreateNew: "Create new",
  From: "From",
  To: "To",
  EnterPinCode: "Enter PIN Code",
  ZeroPriceIsNotAvailable: "Zero price is not available.",
  PaymentReceipt: "Payment Receipt",
  TransactedOn: "Transacted on",
  YouHaveSuccessfullyRegistered: "You have successfully registered",
  ReceiptItems: "Receipt Items",
  Overage: "Overage",
  ErrorButton: "Error Button",
  ForceSync: "Force Sync",
  SyncingErpnextData: "Syncing ERPNEXT data",
  SendPassword: "Send Password",
  Back: "Back",
  Register: "Register",
  Login: "Login",
  CreateAccount: "Create Account",
  FirstName: "First Name",
  LastName: "Last Name",
  ConfirmPassword: "Confirm Password",
  ThereAreItemsAssociatedWithThisCategoryChangeOrDeleteTheItems:
    "There are items associated with this category. Change or delete the items",
  SuccessfullyDeletedCategory: "Successfully Deleted Category",
  SuccessfullyDeletedItem: "Successfully Deleted Item",
  SuccessfullyDeletedDiscount: "Successfully Deleted Discount",
  DeleteCategory: "Delete Category?",
  DeleteItem: "Delete Item?",
  DeleteDiscount: "Delete Discount?",
  WouldYouLikeToDeleteThisCategory: "Would you like to delete this category?",
  WouldYouLikeToDeleteAnItem: "Would you like to delete an item?",
  WouldYouLikeToDeleteThisDiscount: "Would you like to delete this discount?",
  SuccessfullyUpdatedCategory: "Successfully Updated Category",
  SuccessfullyUpdatedItem: "Successfully Updated Item",
  SuccessfullyUpdatedDiscount: "Successfully Updated Discount",
  DiscountValueError: "Discount Value Error",
  ValueCantBeGreaterThan100OrLessThan0:
    "Value cant be greater than 100% or less than 0%",
  BarcodeAlreadyBeenUsed: "Barcode already been used",
  EnterValidItemName: "Enter Valid Item Name",
  SuccessfullyPrintedTheBarcode: "Successfully printed the barcode.",
  UnableToPrint: "Unable to print",
  PleaseConnectYourPrinter: "Please connect your printer",
  CheckYourEmail: "Check Your Email.",
  NetworkConnectionFailed: "Network Connection Failed.",
  ReceiptConfirmation: "Receipt Confirmation",
  InvalidEmail: "Invalid Email",
  PleaseEnterValidEmail: "Please enter valid email",
  AreYouSureYouWantToReprintThisReceipt:
    "Are you sure you want to reprint this receipt?",
  UnableToConnectPrinter: "Unable to connect printer",
  ReprintCompleted: "Reprint Completed",
  EnterValidReason: "Enter Valid Reason",
  TransactionCompleted: "Transaction Completed",
  AllDataWillBeLostWhenYouAreLoggedOutAsOwnerWouldYouLikeToProceed:
    "All data will be lost when you are logged out as owner. Would you like to proceed?",
  Logout: "Logout",
  AttendantAlreadyExists: "Attendant Already Exists",
  SuccessfullyUpdatedAttendant: "Successfully updated attendant",
  PinCodeContainsSpecialCharacters: "Pin code contains special characters",
  DeleteAttendant: "Delete Attendant",
  AreYouSureYouWantToDeleteAttendant:
    "Are you sure you want to delete attendant?",
  SuccessfullyDeletedAttendant: "Successfully Deleted Attendant",
  NoShiftsCreated: "No Shifts Created",
  BluetoothConnectionFailed: "Bluetooth Connection Failed",
  RoleError: "Role Error",
  UnableToGoToListingIfYouAreTheOwnerReLogInAsOwnerInOrderToProceed:
    "Unable to go to listing. If you are the owner, re log-in as owner in order to proceed",
  UnableToRegisterEmailAddressIsAlreadyTaken:
    "Unable to register. Email address is already taken",
  UnableToRegisterConnectionFailed: "Unable to register. Connection failed",
  EmailAlreadyExists: "Email Already Exists",
  EmailIsAvailable: "Email is available",
  InputAValidEmail: "Input a valid email",
  OpenShift: "Open Shift",
  InputValidRole: "Input Valid Role",
  SuccessfullyDeletedRole: "Successfully Deleted Role",
  DeleteRole: "Delete Role",
  AreYouSureYouWantToDeleteRole: "Are you sure you want to delete role?",
  SuccessfullyAddedRole: "Successfully Added Role",

  //Actual Receipts
  Cashier: "Cashier: ",
  TransactionNo: "Transaction No.:",
  Qty: "Qty",
  Purchases: "Purchases",
  TotalAmount: "Total Amount",
  ThisServesAsYour: "This serves as your",
  OfficialReceipt: "Official Receipt",
  POSProvider: "POS Provider:\n",
  AccredNo: "Accred. No.: \n",
  DateIssued: "Date Issued: \n",
  ValidUntil: "Valid Until: \n\n",
  ThisReceiptShallBeValidFor: "THIS RECEIPT SHALL BE VALID FOR\n",
  FiveYearsFromTheDateOf: "FIVE(5) YEARS FROM THE DATE OF\n",
  ThePermitToUse: "THE PERMIT TO USE\n",
  FromDateMustBeGreaterThanOrEqualToDate:
    "(From) date must be greater than or equal (To) date",
  NoItemSalesFrom: "No Item Sales from",
  Date: "Date",
  Type: "Type",
  PrintedBy: "Printed by",
  Closed: "Closed",
  PrintedOn: "Printed on",
  Change: "Change",
  XRreading: "X Reading",
  Language: "Language",
  PleaseRestartTheApplicationToUpdateLanguage:
    "Please restart the application to update language",
  AlreadyUpToDate: "Already up to date",
  SyncSuccessful: "Sync Successful",
  UnableToSync: "Unable to sync",
  InvalidUrl: "Invalid URL",
  CompanySettingsSaved: "Company Settings Saved",
  RestoreDefault: "Restore Default",
  AreYouSureYouWantToRestoreDefaultSettings:
    "Are you sure you want to restore default settings?",
  DefaultSettingsRestored: "Default Settings Restored",
};
